import { useEffect } from "react";

export const useResizeAutoOpen = (setIsDrawerOpen: (val: boolean) => void) => {
    useEffect(() => {
        const handleResize = () => {
            setIsDrawerOpen(window.innerWidth >= 1200);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, [setIsDrawerOpen]);
};